import {
  GET_JOBCATEGORIES,
  GET_JOBCATEGORIES_SUCCESS,
  GET_JOBCATEGORIES_FAIL,
  GET_JOBCATEGORY_DETAILS,
  GET_JOBCATEGORY_DETAILS_SUCCESS,
  GET_JOBCATEGORY_DETAILS_FAIL,
  JOBCATEGORY_CREATE,
  JOBCATEGORY_CREATE_FAIL,
  JOBCATEGORY_CREATE_SUCCESS,
  JOBCATEGORY_DELETE,
  JOBCATEGORY_DELETE_FAIL,
  JOBCATEGORY_DELETE_SUCCESS,
  JOBCATEGORY_UPDATE,
  JOBCATEGORY_UPDATE_FAIL,
  JOBCATEGORY_UPDATE_SUCCESS,
  RESET,
  GET_LOOKUP_JOBCATEGORIES,
  GET_LOOKUP_JOBCATEGORIES_SUCCESS,
  GET_LOOKUP_JOBCATEGORIES_FAIL,
} from "./actionTypes";

export const getJobCategories = (payload) => ({
  type: GET_JOBCATEGORIES,
  payload,
});

export const getJobCategoriesSuccess = (data) => ({
  type: GET_JOBCATEGORIES_SUCCESS,
  payload: data,
});

export const getJobCategoriesFail = (error) => ({
  type: GET_JOBCATEGORIES_FAIL,
  payload: error,
});

export const getLookupJobCategories = () => ({
  type: GET_LOOKUP_JOBCATEGORIES,
});

export const getLookupJobCategoriesSuccess = (data) => ({
  type: GET_LOOKUP_JOBCATEGORIES_SUCCESS,
  payload: data,
});

export const getLookupJobCategoriesFail = (error) => ({
  type: GET_LOOKUP_JOBCATEGORIES_FAIL,
  payload: error,
});

export const getJobCategoryDetails = (id) => ({
  type: GET_JOBCATEGORY_DETAILS,
  payload: id,
});

export const getJobCategoryDetailsSuccess = (data) => ({
  type: GET_JOBCATEGORY_DETAILS_SUCCESS,
  payload: data,
});

export const getJobCategoryDetailsFail = (error) => ({
  type: GET_JOBCATEGORY_DETAILS_FAIL,
  payload: error,
});

export const createJobCategory = (payload) => ({
  type: JOBCATEGORY_CREATE,
  payload,
});

export const createJobCategorySuccess = (response) => ({
  type: JOBCATEGORY_CREATE_SUCCESS,
  payload: response,
});

export const createJobCategoryFail = (error) => ({
  type: JOBCATEGORY_CREATE_FAIL,
  payload: error,
});

export const updateJobCategory = (payload) => ({
  type: JOBCATEGORY_UPDATE,
  payload,
});

export const updateJobCategorySuccess = (response) => ({
  type: JOBCATEGORY_UPDATE_SUCCESS,
  payload: response,
});

export const updateJobCategoryFail = (error) => ({
  type: JOBCATEGORY_UPDATE_FAIL,
  payload: error,
});

export const deleteJobCategory = (payload) => ({
  type: JOBCATEGORY_DELETE,
  payload,
});

export const deleteJobCategorySuccess = (response) => ({
  type: JOBCATEGORY_DELETE_SUCCESS,
  payload: response,
});

export const deleteJobCategoryFail = (error) => ({
  type: JOBCATEGORY_DELETE_FAIL,
  payload: error,
});

export const reset = () => ({
  type: RESET,
});
